import { intl } from '@guestyci/localize';

const defaultTexts = {
  'primaryauth.title': 'Welcome Back',
  'error.username.required': 'Please enter an email',
  'primaryauth.username.placeholder': 'Email',
  'primaryauth.username.tooltip': 'Email',
  'registration.signup.label': 'Not a Guesty member yet?',
  'registration.signup.text': 'Register for a demo',
  'password.forgot.email.or.username.placeholder': 'Email',
  'password.forgot.email.or.username.tooltip': ' Email',
  help: 'Need Help?',
  'error.auth.lockedOut':
    'Too many failed attempts. Please try again in 10 minutes.',
  'errors.E0000004': 'Incorrect email/password, please try again',
  // MFA translations
  'mfa.backToFactors': 'Back to method selection',
  'enroll.choices.description.specific':
    'Guesty requires multifactor authentication to add a layer of security when signing into your {0} account.',
};

const getTranslation = (keyPrefix, textKey) => {
  const translationKey = `${keyPrefix}.${textKey}`;
  const text = defaultTexts[textKey];
  const translated = intl.get(translationKey).d(text);
  return translated;
};

const getOktaTranslations = keyPrefix => {
  const languageOktaKeys = Object.keys(defaultTexts);
  const translations = languageOktaKeys.reduce((acc, key) => {
    const translated = getTranslation(keyPrefix, key);
    return { ...acc, [key]: translated };
  }, {});
  return translations;
};

export default getOktaTranslations;
